import styled, { css } from 'styled-components'

export const StepWrapper = styled.div<{
  padded?: boolean
}>`
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${props => props.theme.spacing.md} ${props => props.theme.outerMargin} ${props => props.theme.spacing.sm};

  ${props =>
    props.theme.accessibilityMode &&
    css`
      padding: 2rem;
    `};

  ${props =>
    props.padded &&
    css`
      padding-bottom: ${props => props.theme.size.bottomBar};
    `};
`
